import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getExtension } from '../../../helpers/helpers'
import { filter } from 'jszip'
import { onGetAdditionalDocuments, showDocumentCarouselFunc } from '../../../config/redux/slice/notapUserSlice'
import { image_extensions } from '../../../constants/english'
import { getRequest } from '../../../helpers/request'
import { appApi } from '../../../utils/endpoints/appApi'

export default function DocumentCarousel({certificateDetails}) {
  const dispatch = useDispatch()
  console.log(certificateDetails)

  const {
        token,
        userData
    } = useSelector((state) => state.authData)

    const {
        certificateManagement:{additionalDocs}
    } = useSelector((state) => state.notapUser)
    const [documentList, setDocumentList] = useState([])
    const [current_file, set_current_file] = useState({});
    const [file_index, set_file_index] = useState(0);


    useEffect(()=>{
        let additionalFiles = Array.from(additionalDocs, (option) => {
          return {
                    url: option.FILE_URL,
                    name: `${option.FILE_NAME}`,
                    ext: getExtension(option.FILE_URL)
                  }
        }
      );
      let dataList = [
      {
        url: certificateDetails?.CERTIFICATE_FILE_PATH,
        name: `Certificate`,
        ext: getExtension(certificateDetails?.CERTIFICATE_FILE_PATH)
      },
      {
        url: certificateDetails?.STAMPED_AGREEMENT,
        name: `Stamped Agreement`,
        ext: getExtension(certificateDetails?.STAMPED_AGREEMENT)
      },
      {
        url: certificateDetails?.COVER_LETTER,
        name: `Cover Letter`,
        ext: getExtension(certificateDetails?.COVER_LETTER)
      },
      ...additionalFiles,
      {
        url: certificateDetails?.CERTIFY_TRUE_COPY,
        name: `Certified True Copy`,
        ext: getExtension(certificateDetails?.CERTIFY_TRUE_COPY)
      },
    ]
    dataList = dataList.filter((listItem)=>listItem.url != null)
    setDocumentList(dataList)
    set_current_file(dataList[0])
    }, [])

    const change_file = direction => {
        let contentUrlLength = documentList.length;
        if (direction === 'previous') {
            set_file_index(previousState => {
                return previousState - 1;
            });
            if (file_index <= 0) {
                set_file_index(previousState => {
                    return contentUrlLength - 1;
                });
            }
        } else if (direction === 'next') {
            set_file_index(previousState => {
                return previousState + 1;
            });
            if (file_index >= contentUrlLength - 1) {
                set_file_index(previousState => {
                    return 0;
                });
            }
        }

        set_current_file(documentList[file_index]);

    };

    const closeModal = (e) => {
      if(e.currentTarget == e.target){
        dispatch(showDocumentCarouselFunc({modal: false}))
      }
    }

  return (
        <div 
        onClick={closeModal}
        className="modal fade show" 
        id="basicModal" 
        tabIndex="-1"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.3)",
          overflowY: 'auto'
        }}
     >
  <div style={{overflowY: 'auto'}} className="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div style={{backgroundColor: 'transparent', border: 'none'}} className="modal-content">
       <div className="d-flex justify-content-center align-items-center">
            <button
            style={{fontSize: '3rem'}}
                className="carousel-btn mr-1"
                onClick={() => {
                    change_file('previous');
                }}
            >
                <i className="mdi mdi-chevron-left"></i>
            </button>
            {image_extensions.includes((getExtension(current_file.ext)).toLowerCase()) ? 
                <img className='certificate-img-modal rounded' src={current_file.url} alt="Slide Image"/>
                :
                <iframe style={{width: '90%'}} className='certificate-pdf-modal pdf' src={current_file.url} title='Certificate PDF'></iframe>
            }
            {/* {(() => {
                if (allowed_image_format.includes(getExtension(current_file))) {
                    return <img className="content-img" src={current_file} />;
                } else if (allowed_video_format.includes(getExtension(current_file))) {
                    return (
                        <Player src={current_file} className="content-img">
                            <BigPlayButton position="center" />
                        </Player>
                    );
                } else {
                    return (
                        <img
                            className="content-img"
                            src={current_file}
                            alt="Media format not supported by browser"
                            style={{ width: '100%', height: '100%' }}
                        />
                    );
                }
            })()} */}
            <button
            style={{fontSize: '3rem'}}
                className="carousel-btn ml-1"
                onClick={() => {
                    change_file('next');
                }}
            >
                <i className="mdi mdi-chevron-right"></i>
            </button>
        </div>
    </div>
  </div>
</div>
  )
}
